<template>
  <div>
    <div class="sm:hidden">
      <label for="tabs" class="sr-only">Select a tab</label>
      <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
      <select
        id="tabs"
        name="tabs"
        class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
      >
        <option v-for="tab in tabs" :key="tab.label" :selected="tab.isActive()">
          {{ tab.name }}
        </option>
      </select>
    </div>
    <div class="hidden sm:block">
      <div class="border-b border-gray-200">
        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
          <RouterLink
            v-for="tab in tabs"
            :key="tab.label"
            :to="tab.route"
            custom
            v-slot="{ navigate, isActive }"
          >
            <a
              :active="isActive"
              @click="navigate"
              :aria-current="tab.isActive() ? 'page' : undefined"
              :class="[
                tab.isActive()
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                'group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer',
              ]"
            >
              <span>{{ tab.label }}</span>
              <span
                v-if="tab.meta.count"
                :class="[
                  tab.isActive() ? 'bg-indigo-100 text-indigo-600' : 'bg-gray-100 text-gray-900',
                  'hidden ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium md:inline-block',
                ]"
                >{{ tab.meta.count }}</span
              >
            </a>
          </RouterLink>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tabs() {
      const vm = this;

      return [
        {
          label: 'Overview',
          route: {
            name: 'accounts.smsCampaigns.smsCampaignId.overview',
            params: {
              accountId: this.smsCampaign.account_id,
              smsCampaignId: this.smsCampaign.id,
            },
          },
          meta: {},
          isActive() {
            return vm.$route.name === this.route.name;
          },
        },
        {
          label: 'Sending Logs',
          route: {
            name: 'accounts.smsCampaigns.smsCampaignId.trackingLogs',
            params: {
              accountId: this.smsCampaign.account_id,
              smsCampaignId: this.smsCampaign.id,
            },
          },
          meta: {},
          isActive() {
            return vm.$route.name === this.route.name;
          },
        },
        {
          label: 'Settings',
          route: {
            name: 'accounts.smsCampaigns.smsCampaignId.edit',
            params: {
              accountId: this.smsCampaign.account_id,
              smsCampaignId: this.smsCampaign.id,
            },
          },
          meta: {},
          isActive() {
            return vm.$route.name === this.route.name;
          },
        },
      ];
    },
  },
};
</script>
